module.exports = __webpack_public_path__ + "img/geofisica3_4-3_3072.56e6c0e7.webp";